import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Stats = _resolveComponent("Stats")!
  const _component_Skills = _resolveComponent("Skills")!
  const _component_Products = _resolveComponent("Products")!
  const _component_Team = _resolveComponent("Team")!
  const _component_Contact = _resolveComponent("Contact")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_CookiesBanner = _resolveComponent("CookiesBanner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createVNode(_component_Stats),
    _createVNode(_component_Skills),
    _createVNode(_component_Products),
    _createVNode(_component_Team),
    _createVNode(_component_Contact, { id: "kontakt" }),
    _createVNode(_component_Footer),
    _createVNode(_component_CookiesBanner)
  ], 64))
}